import { motion, useMotionValue, useTransform } from "framer-motion";
import { useEffect, useState, useRef } from "react";

/* 🔥 DATA */
const sets = [
  {
    before: "https://res.cloudinary.com/dge0knh7q/image/upload/v1775909388/1_d5tet1.png",
    after: "https://res.cloudinary.com/dge0knh7q/image/upload/v1775909386/2_bkxkrl.png",
    uplift: "+72%",
  },
  {
    before: "https://res.cloudinary.com/dge0knh7q/image/upload/v1775909387/3_bvaxvm.png",
    after: "https://res.cloudinary.com/dge0knh7q/image/upload/v1775909388/4_xgrvmf.png",
    uplift: "+64%",
  },
];

export default function FeatureVisualInteriors() {
  const [index, setIndex] = useState(0);
  const containerRef = useRef(null);

  const x = useMotionValue(0.5);
  const clipPath = useTransform(x, (v) => `inset(0 ${(1 - v) * 100}% 0 0)`);
  const handleLeft = useTransform(x, (v) => `${v * 100}%`);

  /* 🔁 AUTO SLIDE */
  useEffect(() => {
    const interval = setInterval(() => {
      x.set(0.3);
      setTimeout(() => x.set(0.7), 1200);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  /* 🔁 ROTATE PROPERTY */
  useEffect(() => {
    const i = setInterval(() => {
      setIndex((i) => (i + 1) % sets.length);
    }, 8000);

    return () => clearInterval(i);
  }, []);

  const current = sets[index];

  const handleDrag = (e, info) => {
    const rect = containerRef.current.getBoundingClientRect();
    let newX = (info.point.x - rect.left) / rect.width;
    newX = Math.max(0.05, Math.min(0.95, newX));
    x.set(newX);
  };

  return (
    <div ref={containerRef} className="w-full h-full relative overflow-hidden rounded-[28px]">

      {/* 🔥 BACKGROUND */}
      <img
        src={current.after}
        className="absolute inset-0 w-full h-full object-cover scale-105"
      />

      {/* 🔥 OVERLAY */}
      <div className="absolute inset-0 bg-black/50" />

      {/* 🔥 MAIN CONTENT */}
      <div className="relative z-10 h-full flex flex-col justify-between p-6">

        {/* TOP */}
        <div className="flex justify-between">
          <div>
            <div className="text-white font-semibold text-[16px]">
              Interior optimisation
            </div>
            <div className="text-white/70 text-[13px]">
              Designed to increase bookings
            </div>
          </div>

          <span className="text-[11px] text-white/70">
            Live project
          </span>
        </div>

        {/* 🔥 CENTER SLIDER */}
        <div className="relative w-full h-[55%] rounded-xl overflow-hidden border border-white/10">

          {/* AFTER */}
          <img
            src={current.after}
            className="absolute inset-0 w-full h-full object-cover"
          />

          {/* BEFORE */}
          <motion.img
            src={current.before}
            style={{ clipPath }}
            className="absolute inset-0 w-full h-full object-cover"
          />

          {/* SLIDER */}
          <motion.div
            drag="x"
            dragElastic={0}
            dragMomentum={false}
            onDrag={handleDrag}
            style={{ left: handleLeft }}
            className="absolute top-0 bottom-0 w-[2px] bg-white z-20 cursor-ew-resize"
          >
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-7 h-7 bg-white rounded-full shadow-lg" />
          </motion.div>

          {/* LABELS */}
          <div className="absolute top-3 left-3 right-3 flex justify-between text-[11px] text-white/80">
            <span>Before</span>
            <span>After Zenia</span>
          </div>

        </div>

        {/* 🔥 SIDE INFO */}
        <div className="grid grid-cols-2 gap-4">

          {/* BEFORE PROBLEMS */}
          <div className="bg-white/10 backdrop-blur rounded-xl p-3">
            <div className="text-[11px] text-white/60 mb-1">
              Before issues
            </div>
            <div className="text-[13px] text-white">
              Poor lighting  
              <br /> Weak presentation  
              <br /> Low conversion
            </div>
          </div>

          {/* AFTER IMPROVEMENT */}
          <div className="bg-white/10 backdrop-blur rounded-xl p-3">
            <div className="text-[11px] text-white/60 mb-1">
              After Zenia
            </div>
            <div className="text-[13px] text-white">
              Optimised design  
              <br /> Better photos  
              <br /> Higher demand
            </div>
          </div>

        </div>

        {/* 🔥 BOTTOM RESULT */}
        <motion.div
          key={current.uplift}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center"
        >
          <span className="text-[14px] text-emerald-400 font-semibold">
            {current.uplift} revenue increase
          </span>
        </motion.div>

      </div>

      {/* 🔥 GLOW */}
      <div className="absolute -bottom-20 -left-20 w-[300px] h-[300px] bg-brand-primary/20 blur-3xl rounded-full" />

    </div>
  );
}